import { useParams } from "react-router-dom";
import { useProjectApi } from "../../hooks/useProjectApi";
import { useCreateTableData } from "../Table/hooks";
import BulkCopyButton from "./BulkCopyButton";
import { loadRegistrationCopy } from "./registrationCopy";

export default function RegistrationCopyButton({ kind, onCopied, disabled }) {
  const { group_code, project_code } = useParams();
  const api = useProjectApi(group_code, project_code);
  const mutation = useCreateTableData("request", kind === "machine" ? "/postRegisterAsset" : "/postRegisterCause", group_code, project_code);
  return <BulkCopyButton key={`${group_code}/${project_code}/${kind}`} kind={kind}
    label={kind === "machine" ? "공정 연결 복사" : "유해·위험요인 연결 복사"}
    disabled={disabled || mutation.isPending}
    loadSnapshot={() => loadRegistrationCopy(api, kind)}
    saveCopy={(payload) => mutation.mutateAsync(payload)} onCopied={onCopied} />;
}
